import NewspaperExpirationMessageForm from './NewspaperExpirationMessageForm'
export default NewspaperExpirationMessageForm
